import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { Icon } from 'views/components/Icon/Icon';
import classNames from 'classnames';


interface Props {
  intl: IntlShape;
  activeReferralCode?: string;
  onApplyReferralCode: (referralCode: string) => void;
  error?: string | boolean;
}

const ReferralCodeInputView = (props: Props) => {
  const {
    intl, activeReferralCode, onApplyReferralCode, error,
  } = props;

  const applyReferralCode = (referralCode: string) => {
    onApplyReferralCode(referralCode ?? '');
  };

  return (
    <div className="ReferralCodeInput">
      <div className="ReferralCodeInput-container">
        <legend>
          <FormattedMessage id="REFERRAL_CODE" />
        </legend>

        <label className="ReferralCodeInput-label" htmlFor="referralCode">
          <span className="u-hiddenVisually">
            <FormattedMessage id="REFERRAL_CODE" />
          </span>

          <input
            id="referralCode"
            className={classNames('ReferralCodeInput-input', { hasError: !!error })}
            type="text"
            value={activeReferralCode}
            maxLength={12}
            onChange={(e) => applyReferralCode(e.target.value)}
            placeholder={intl.formatMessage({ id: 'REFERRAL_CODE_PLACEHOLDER' })}
          />
        </label>
      </div>

      {/* Screen reader error message */}
      {error && (
      <span className="u-hiddenVisually" aria-live="polite">
        {error}
      </span>
      )}

      {/* UI visible error message */}
      {error && (
      <div className="RadioInput-error">
        <Icon name="ic-exclamation" />
        <span>{error}</span>
      </div>
      )}
    </div>
  );
};

export const ReferralCodeInput = injectIntl(ReferralCodeInputView);
